import React from 'react';
import { moreTestimonials } from '../data/constants';
export function MoreTestimonials() {
  return <section className="py-20 px-4 max-w-5xl mx-auto" data-id="element-147">
      <h2 className="text-3xl font-bold text-center mb-12 flex items-center justify-center gap-2" data-id="element-148">
        <span data-id="element-149">❤️</span> MÁS PROFES QUE YA LO TIENEN
      </h2>

      <div className="grid md:grid-cols-2 gap-6" data-id="element-150">
        {moreTestimonials.map((t, i) => <div key={i} className="bg-surface border border-zinc-800 p-6 rounded-2xl flex flex-col" data-id="element-151">
            <div className="flex items-center gap-3 mb-4" data-id="element-152">
              <div className="w-12 h-12 rounded-full bg-zinc-800 flex items-center justify-center font-space-grotesk font-bold text-lg text-zinc-300 shrink-0" data-id="element-153">
                {t.initials}
              </div>
              <div data-id="element-154">
                <div className="font-bold text-white flex items-center gap-2" data-id="element-155">
                  {t.name}{' '}
                  <span className="text-xs font-normal text-zinc-500" data-id="element-156">
                    {t.location}
                  </span>
                </div>
                <div className="text-xs text-primary font-medium mt-0.5" data-id="element-157">
                  {t.role}
                </div>
              </div>
            </div>
            <div className="text-yellow-400 text-sm mb-3" data-id="element-158">⭐⭐⭐⭐⭐</div>
            <p className="text-zinc-300 italic flex-grow text-sm" data-id="element-159">"{t.text}"</p>
          </div>)}
      </div>
    </section>;
}